<template>
  <div>
    <div class="container mx-auto ">
      <!--专栏s-->
      <div class="mb-20 mt-25 bg-w p-10 flex flex-wrap">
        <div
            class="text-14 text-gray-900 mx-10 my-5 py-8 px-20 ss-cate-item rounded-full cursor-pointer"
            :class="[column_id==item.id?'active':'']"
            v-for="(item, index) in columnList"
            :key="index"
        >
          <div @click="changeColumn(item.id)">{{ item.name }}</div>
        </div>
      </div>
      <!--专栏e-->

      <div class="flex justify-between mt-20">
        <div class="ss-news-l">
          <div v-if="totalNum==0" class="ss-w flex items-center justify-center">
            <img src="@/assets/images/news.png"/>
          </div>

          <div
              v-else
              class="flex cur-point1 items-center ss-news-l-item mb-20 bg-white p-15"
              v-for="(item, index) in columnDetailList"
              :key="index"
              @click="toPostDetail(item.id)"
          >
            <div class="flex-none ss-news-l-img rounded mr-35">
              <img :src="item.cover" alt class="rounded"/>
            </div>
            <div class="post-item self-start">
              <div class="fs-18 text-gray-901 font-bold f-size">{{ item.title }}</div>
              <div class="fs-18 text-gray-501 fs-14 py-10">{{ item.createtime }}</div>
              <div class="fs-18 text-gray-501 fs-14 py-10 manyline">{{ item.summary }}</div>
            </div>
            <div class="self-end">
              <div>
                <span class="iconfont icon-views text-gray-501">{{ item.views }}</span>
              </div>
            </div>
          </div>
          <div class="pagination flex justify-center mb-100 mt-50" v-if="totalNum>10">
            <a-pagination :pageSize="10" v-model="page" :total="totalNum" @change="onChange"/>
          </div>
        </div>
        <div class="ss-news-r">
          <div class="bg-white px-30 overflow-hidden cur-point1 b-r">
            <div class="my-30 fs-19 text-gray-900 font-bold f-size-20">热门文章</div>
            <div
                v-for="(item, index) in hotList"
                class="my-20"
                :key="index"
                @click="toPostDetail(item.id)"
            >
              <div class="fs-16 text-gray-900 flex items-center f-size-16">
                <img :src="arrImg" class="arr-img"/>
                <span class="no-wrap c-666">{{ item.title }}</span>
              </div>
              <div class="text-gray-501 fs-12 mt-15 flex justify-between">
                <span>{{ item.createtime }}</span>
                <span class="iconfont icon-views">{{ item.views }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      columnList: [],//专栏的接口列表
      column_id: 0,//专栏的id
      page: 1,//当前专栏的当前页页
      totalNum: 0,//当前专栏中文章总数
      columnDetailList: [],//内容资讯的列表
      hotList: [],// 热门的列表
      id: '',
      arrImg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAAiklEQVQYlXXOMQ4BYRCG4WfFCVSUTrANTiEcQKnS7SEoVY7AAbiCSiMaEmcQEbWQyBSb/FnrS6aZ950vkw1n7yUWeKhJA11cMP4nHNDGFhu06oQyE5wxSoUjPonUwQ7raGsiJsRqou0WsI+sQk8osI/LQQLumKIXMBZlwwsrzPFMq0KIRY7rzxf4AupAGBCnWwSNAAAAAElFTkSuQmCC'
    }
  },
  methods: {
    async getListAll() {//获取所有的列表接口
      const res_1 = await this.$http.get('index.php/user/internal/column') // 获取栏目接口
      this.columnList = res_1.data
      console.log(res_1, '获取栏目接口')
      if (this.columnList.length > 0) {
        this.column_id = this.columnList[0].id
        const res_2 = await this.$http.get('index.php/user/internal/articles_list', {
          page: 1,
          pageSize: 10,
          column_id: this.column_id
        })//内容资讯的列表接口
        console.log(res_2, '内容资讯的接口')
        this.page = res_2.data.current_page
        this.totalNum = res_2.data.total
        this.columnDetailList = res_2.data.data
      }
      const res_3 = await this.$http.get('index.php/user/internal/views_list') // 热门推荐接口
      this.hotList = res_3.data
      console.log(res_3, '热门推荐的接口')
    },
    // 获取不同专栏下的文章
    async getColumnPost(id, page) {
      const res1 = await this.$http.get('index.php/user/internal/articles_list', {
        column_id: id,
        pageSize: 10,
        page: page
      })
      console.log(res1, '改变专栏文章')
      this.columnDetailList = res1.data.data
      this.totalNum = res1.data.total
      console.log(this.columnDetailList, '改变专栏文章改变专栏文章改变专栏文章改变专栏文章')
    },
    changeColumn(id, page) {
      console.log(page)
      this.getColumnPost(id, page)
      this.column_id = id
    },
    // 分页
    onChange(page) {
      this.page = page - 0
      this.getColumnPost(this.column_id, page - 0)
    },

    // 跳转文章详情页
    toPostDetail(id) {
      this.$router.push(`/news/detail?id=${id}`)
    }

  },
  created() {
    this.getListAll()
  }
}
</script>

<style scoped>
/* .container {
  min-height: 69vh;
} */

.manyline {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 90px;
  margin: 0px 10px 0px 0px;
}

.ss-w {
  width: 100%;
  height: 100%;
}

.active {
  background: #eff5ff;
  color: #5173f5 !important;
}

.bg-w {
  background-color: #fff;
}

.b-r {
  border-radius: 4px;
}

.icon-views {
  font-size: 12px;
}

.icon-views::before {
  margin-right: 10px;
}

.post-item {
  width: 60%;
}

.ss-news-l {
  width: 850px;
}

.ss-news-l-img,
.ss-news-l-img img {
  width: 250px;
  height: 160px;
}

.ss-news-l-item {
  border-radius: 10px;
}

.ss-news-r {
  width: 330px;
}

.ss-zl-btn {
  border-radius: 1000px;
  border: 1px solid #d8d8d8;
}

.ss-zl-btn.active {
  /* background: #5173f5; */
  color: #5173f5 !important;
  border: 1px solid #5173f5;
}

.cur-point:hover {
  cursor: pointer;
  border: 1px solid #5173f5;
}

.cur-point1:hover {
  cursor: pointer;
}

.arr-img {
  width: 8px;
  height: 10px;
  margin-right: 5px;
}

.no-wrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ss-size {
  padding: 8px 36px;
  box-sizing: border-box;
  font-size: 18px;
  color: #666;
  display: block;
}

.f-size {
  font-size: 18px;
}

.f-size-20 {
  font-size: 20px;
}

.f-size-16 {
  font-size: 16px;
}

.c-666 {
  color: #666;
}

/* .mh997 {
  min-height: 997px;
} */
</style>
